import { render, staticRenderFns } from "./NotificationFeedItem.vue?vue&type=template&id=62bd1de2"
import script from "./NotificationFeedItem.vue?vue&type=script&lang=js"
export * from "./NotificationFeedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports